<template>
  <div class="couponBox">
    <div class="header-box">
      <div class="couponTitle">
        <div class="title">
          SKU最低价限定
        </div>
        <div class="button"></div>
      </div>
      <div class="couponSearch">
        <el-button type="primary" @click="onSubmit">设置</el-button>
      </div>
    </div>
    <div class="content-top">
      <p class="top-title">默认会员最低限价：</p>
      <el-row :gutter="20">
        <el-col :span="6" class="col-style">
          <span>
            基础会员(月卡)：
            <el-input
              v-model="form.common_vip_month"
              placeholder="请输入内容"
              @input="change($event)"
            ></el-input>
          </span>
        </el-col>
        <el-col :span="6">
          <span>
            基础会员(季卡)：
            <el-input
              v-model="form.common_vip_jk"
              placeholder="请输入内容"
              @input="change($event)"
            ></el-input>
          </span>
        </el-col>
        <el-col :span="6">
          <span>
            基础会员(年卡)：
            <el-input
              v-model="form.common_vip_year"
              placeholder="请输入内容"
              @input="change($event)"
            ></el-input>
          </span>
        </el-col>
        <el-col :span="6">
          <span>
            基础会员(双年卡)：
            <el-input
              v-model="form.common_vip_year_double"
              placeholder="请输入内容"
              @input="change($event)"
            ></el-input>
          </span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6" class="col-style">
          <span>
            学霸会员(月卡)：
            <el-input
              v-model="form.high_vip_month"
              placeholder="请输入内容"
              @input="change($event)"
            ></el-input>
          </span>
        </el-col>
        <el-col :span="6">
          <span>
            学霸会员(季卡)：
            <el-input
              v-model="form.high_vip_jk"
              placeholder="请输入内容"
              @input="change($event)"
            ></el-input>
          </span>
        </el-col>
        <el-col :span="6">
          <span>
            学霸会员(年卡)：
            <el-input
              v-model="form.high_vip_year"
              placeholder="请输入内容"
              @input="change($event)"
            ></el-input>
          </span>
        </el-col>
        <el-col :span="6">
          <span>
            学霸会员(双年卡)：
            <el-input
              v-model="form.high_vip_year_double"
              placeholder="请输入内容"
              @input="change($event)"
            ></el-input>
          </span>
        </el-col>
      </el-row>
    </div>

    <div class="content-top">
      <p class="top-title">活动会员价格：</p>
      <el-row :gutter="20">
        <el-col :span="8">
          <span>
            基础会员(月卡)：
            <el-input
              v-model="activity_common_vip_month_price"
              placeholder="请输入内容"
              @input="change($event)"
            ></el-input>
          </span>
        </el-col>
        <el-col :span="16">
          <span>
            生效起止时间：
            <el-date-picker
              v-model="formDate.activity_common_vip_month_date"
              type="daterange"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <span>
            基础会员(季卡)：
            <el-input
              v-model="activity_common_vip_jk_price"
              placeholder="请输入内容"
              @input="change($event)"
            ></el-input>
          </span>
        </el-col>
        <el-col :span="16">
          <span>
            生效起止时间：
            <el-date-picker
              v-model="formDate.activity_common_vip_jk_date"
              type="daterange"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <span>
            基础会员(年卡)：
            <el-input
              v-model="activity_common_vip_year_price"
              placeholder="请输入内容"
              @input="change($event)"
            ></el-input>
          </span>
        </el-col>
        <el-col :span="16">
          <span>
            生效起止时间：
            <el-date-picker
              v-model="formDate.activity_common_vip_year_date"
              type="daterange"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <span>
            基础会员(双年卡)：
            <el-input
              v-model="activity_common_vip_year_double_price"
              placeholder="请输入内容"
              @input="change($event)"
            ></el-input>
          </span>
        </el-col>
        <el-col :span="16">
          <span>
            生效起止时间：
            <el-date-picker
              v-model="formDate.activity_common_vip_year_double_date"
              type="daterange"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <span>
            学霸会员(月卡)：
            <el-input
              v-model="activity_high_vip_month_price"
              placeholder="请输入内容"
              @input="change($event)"
            ></el-input>
          </span>
        </el-col>
        <el-col :span="16">
          <span>
            生效起止时间：
            <el-date-picker
              v-model="formDate.activity_high_vip_month_date"
              type="daterange"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <span>
            学霸会员(季卡)：
            <el-input
              v-model="activity_high_vip_jk_price"
              placeholder="请输入内容"
              @input="change($event)"
            ></el-input>
          </span>
        </el-col>
        <el-col :span="16">
          <span>
            生效起止时间：
            <el-date-picker
              v-model="formDate.activity_high_vip_jk_date"
              type="daterange"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <span>
            学霸会员(年卡)：
            <el-input
              v-model="activity_high_vip_year_price"
              placeholder="请输入内容"
              @input="change($event)"
            ></el-input>
          </span>
        </el-col>
        <el-col :span="16">
          <span>
            生效起止时间：
            <el-date-picker
              v-model="formDate.activity_high_vip_year_date"
              type="daterange"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <span>
            学霸会员(双年卡)：
            <el-input
              v-model="activity_high_vip_year_double_price"
              placeholder="请输入内容"
              @input="change($event)"
            ></el-input>
          </span>
        </el-col>
        <el-col :span="16">
          <span>
            生效起止时间：
            <el-date-picker
              v-model="formDate.activity_high_vip_year_double_date"
              type="daterange"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </span>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import http from "../../../api/knowledgeApiConfig";
export default {
  data() {
    return {
      formInline: {},
      form: {},
      formDate: {},
      allData: [],
      activity_common_vip_month_price: "",
      activity_common_vip_jk_price: "",
      activity_common_vip_year_price: "",
      activity_common_vip_year_double_price: "",
      activity_high_vip_month_price: "",
      activity_high_vip_jk_price: "",
      activity_high_vip_year_price: "",
      activity_high_vip_year_double_price: "",
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      http.get("admin/coupon/get_sku_price").then((res) => {
        if (res.data.status_code == 200) {
          let data = res.data.data;
          this.allData = data;
          // 默认会员
          this.form.common_vip_month = data[0].value;
          this.form.common_vip_jk = data[1].value;
          this.form.common_vip_year = data[2].value;
          this.form.common_vip_year_double = data[3].value;
          this.form.high_vip_month = data[4].value;
          this.form.high_vip_jk = data[5].value;
          this.form.high_vip_year = data[6].value;
          this.form.high_vip_year_double = data[7].value;
          // 活动会员
          this.activity_common_vip_month_price = data[8].value;
          this.activity_common_vip_jk_price = data[9].value;
          this.activity_common_vip_year_price = data[10].value;
          this.activity_common_vip_year_double_price = data[11].value;
          this.activity_high_vip_month_price = data[12].value;
          this.activity_high_vip_jk_price = data[13].value;
          this.activity_high_vip_year_price = data[14].value;
          this.activity_high_vip_year_double_price = data[15].value;
          this.$set(this.formDate, "activity_common_vip_month_date", [
            data[8].start_time,
            data[8].end_time,
          ]);
          this.$set(this.formDate, "activity_common_vip_jk_date", [
            data[9].start_time,
            data[9].end_time,
          ]);
          this.$set(this.formDate, "activity_common_vip_year_date", [
            data[10].start_time,
            data[10].end_time,
          ]);
          this.$set(this.formDate, "activity_common_vip_year_double_date", [
            data[11].start_time,
            data[11].end_time,
          ]);
          this.$set(this.formDate, "activity_high_vip_month_date", [
            data[12].start_time,
            data[12].end_time,
          ]);
          this.$set(this.formDate, "activity_high_vip_jk_date", [
            data[13].start_time,
            data[13].end_time,
          ]);
          this.$set(this.formDate, "activity_high_vip_year_date", [
            data[14].start_time,
            data[14].end_time,
          ]);
          this.$set(this.formDate, "activity_high_vip_year_double_date", [
            data[15].start_time,
            data[15].end_time,
          ]);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    onSubmit() {
      this.form.activity_common_vip_month = {
        price: this.activity_common_vip_month_price,
        start_time: this.formDate.activity_common_vip_month_date[0],
        end_time: this.formDate.activity_common_vip_month_date[1],
      };
      this.form.activity_common_vip_month = JSON.stringify(
        this.form.activity_common_vip_month
      );

      this.form.activity_common_vip_jk = {
        price: this.activity_common_vip_jk_price,
        start_time: this.formDate.activity_common_vip_jk_date[0],
        end_time: this.formDate.activity_common_vip_jk_date[1],
      };
      this.form.activity_common_vip_jk = JSON.stringify(
        this.form.activity_common_vip_jk
      );

      this.form.activity_common_vip_year = {
        price: this.activity_common_vip_year_price,
        start_time: this.formDate.activity_common_vip_year_date[0],
        end_time: this.formDate.activity_common_vip_year_date[1],
      };
      this.form.activity_common_vip_year = JSON.stringify(
        this.form.activity_common_vip_year
      );

      this.form.activity_common_vip_year_double = {
        price: this.activity_common_vip_year_double_price,
        start_time: this.formDate.activity_common_vip_year_double_date[0],
        end_time: this.formDate.activity_common_vip_year_double_date[1],
      };
      this.form.activity_common_vip_year_double = JSON.stringify(
        this.form.activity_common_vip_year_double
      );

      this.form.activity_high_vip_month = {
        price: this.activity_high_vip_month_price,
        start_time: this.formDate.activity_high_vip_month_date[0],
        end_time: this.formDate.activity_high_vip_month_date[1],
      };
      this.form.activity_high_vip_month = JSON.stringify(
        this.form.activity_high_vip_month
      );

      this.form.activity_high_vip_jk = {
        price: this.activity_high_vip_jk_price,
        start_time: this.formDate.activity_high_vip_jk_date[0],
        end_time: this.formDate.activity_high_vip_jk_date[1],
      };
      this.form.activity_high_vip_jk = JSON.stringify(
        this.form.activity_high_vip_jk
      );

      this.form.activity_high_vip_year = {
        price: this.activity_high_vip_year_price,
        start_time: this.formDate.activity_high_vip_year_date[0],
        end_time: this.formDate.activity_high_vip_year_date[1],
      };
      this.form.activity_high_vip_year = JSON.stringify(
        this.form.activity_high_vip_year
      );

      this.form.activity_high_vip_year_double = {
        price: this.activity_high_vip_year_double_price,
        start_time: this.formDate.activity_high_vip_year_double_date[0],
        end_time: this.formDate.activity_high_vip_year_double_date[1],
      };
      this.form.activity_high_vip_year_double = JSON.stringify(
        this.form.activity_high_vip_year_double
      );
      http.post("admin/coupon/set_sku_Price", this.form).then((res) => {
        if (res.data.status_code == 200) {
          this.$message.success("设置成功");
          this.getData();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    change() {
      this.$forceUpdate();
    },
  },
};
</script>

<style lang="scss" scoped>
.couponBox {
  width: 100%;
  height: 100%;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 20px;
  box-sizing: border-box;
  .header-box {
    display: flex;
    justify-content: space-between;
    .couponSearch {
      margin-right: 20px;
      display: flex;
      align-items: center;
    }
    .couponTitle {
      width: 100%;
      display: flex;
      flex-direction: column;
      .title {
        font-size: 22px;
        font-weight: bold;
      }
    }
  }
  .content-top {
    width: 100%;
    .top-title {
      padding: 10px 0 20px 0;
      font-size: 16px;
      font-weight: bold;
    }
  }
}
.nBuild-title {
  padding: 20px;
  color: #169bd5;
}
.border {
  width: 100%;
  height: 1px;
  margin: 10px 0;
  background-image: linear-gradient(
    to right,
    rgb(121, 121, 121) 0%,
    rgb(121, 121, 121) 50%,
    transparent 50%
  );
  background-size: 20px 2px;
  background-repeat: repeat-x;
}
.el-input {
  width: 200px;
}
.el-row {
  margin-bottom: 20px;
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border: 1px solid #000;
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.couponStateBox {
  width: 100%;
  margin-top: 20px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.couponState {
  display: flex;
  align-items: center;
}
.look-thumb {
  display: block;
  width: 178px;
  height: 178px;
}
.avatar {
  width: 178px;
  height: 178px;
  line-height: 178px;
  display: block;
  max-width: 100%;
  text-align: center;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.center {
  display: flex;
  align-items: center;
}
/deep/.ml10 {
  margin: 0 !important;
  margin-top: 15px !important;
}
</style>
